const handleChangeNumber = (setValue) => (e) => {
    setValue(Number(e.target.value))
}

export default handleChangeNumber;